/**
 * Muss an dieser Stelle gewartet werden?
 *
 * `vorlauf` ist der Vorsprung, den der geladene Bereich haben muss: genau
 * bis zur gesuchten Stelle geladen heisst, im nächsten Augenblick fehlt es
 * wieder. `nachlauf` ist die Toleranz nach hinten -- eine Stelle ein paar
 * Hundertstel vor dem Bereich gilt als drin, sonst hält die Wiedergabe an
 * jedem Rundungsfehler an.
 */
/** Darunter wird angehalten: weniger als das ist kein Vorsprung. */
export const VORLAUF_HALT = 0.3;
/**
 * Und erst damit geht es weiter (7.69r).
 *
 * Sascha, 10. September: „Jetzt drückt es ganz oft Pause und Play, wenn es an
 * die Stelle kommt. Also irgendein Loop.“ Genau das, und der Grund war *eine
 * Schwelle für beides*: angehalten wurde bei weniger als drei Zehnteln
 * Vorsprung, und weitergelaufen ist es, sobald wieder drei Zehntel da waren.
 * Drei Zehntel Vorsprung sind nach drei Zehnteln aufgebraucht -- also hielt
 * es sofort wieder an. Anhalten, weiter, anhalten, weiter, fünfmal in der
 * Sekunde.
 *
 * Jeder Abspieler löst das gleich: **anhalten bei fast leer, weiterlaufen
 * erst bei ein paar Sekunden.** Zwei Schwellen statt einer, und dazwischen
 * ist Ruhe.
 */
export const VORLAUF_WEITER = 2;
/**
 * Reicht das Geladene, um *wieder anzufangen*?
 *
 * `rest` ist, wie viel von diesem Clip überhaupt noch kommt: am Ende eines
 * Clips gibt es keine zwei Sekunden Vorsprung mehr, und darauf zu warten
 * hiesse, vor jedem Schnitt hängenzubleiben. Verlangt wird deshalb der
 * kleinere der beiden Werte.
 */
export function pufferSatt(stand, soll, rest = Infinity, vorlauf = VORLAUF_WEITER, nachlauf = 0.05) {
    // Warten hilft hier nicht -- weiterlaufen ist besser als ewig stehen.
    if (stand.fehler)
        return true;
    if (stand.bereit >= 4)
        return true;
    const noetig = Math.max(0, Math.min(vorlauf, rest));
    for (const bereich of stand.geladen) {
        const [von, bis] = bereich;
        if (soll >= von - nachlauf && soll + noetig <= bis)
            return true;
    }
    return false;
}
export function pufferBedarf(stand, soll, vorlauf = VORLAUF_HALT, nachlauf = 0.05) {
    if (stand.fehler)
        return false;
    if (stand.bereit >= 3)
        return false;
    for (const bereich of stand.geladen) {
        const [von, bis] = bereich;
        if (soll >= von - nachlauf && soll + vorlauf <= bis)
            return false;
    }
    return true;
}
/**
 * Wie viel Vorrat verlangt wird, wenn schon `gewartetMs` gewartet wurde
 * (7.69t).
 *
 * Zwei Sekunden sind die richtige Zahl für den Anfang: weniger, und es hält
 * gleich wieder an. Aber sie sind die falsche Zahl für eine Leitung, die
 * keine zwei Sekunden liefert -- der Befund vom iPhone, 11. September:
 * `msMax: 8160`, `abgelaufen: 1`. Die Wartezeit lief in die Acht-Sekunden-
 * Grenze und die Wiedergabe ruckte danach ohnehin los. Aus „Flackern“ war
 * „einmal acht Sekunden stehen“ geworden.
 *
 * Also sinkt die Forderung mit der Wartezeit: volle zwei Sekunden in der
 * ersten, danach linear herunter bis auf ein Minimum. Wer lange genug
 * gewartet hat, nimmt, was da ist -- und das ist immer noch mehr als die
 * drei Zehntel, mit denen es losging.
 */
export const VORLAUF_MINDEST = 0.6;
const NACHLASS_AB = 1000;
const NACHLASS_BIS = 5000;
export function noetigerVorrat(gewartetMs, voll = VORLAUF_WEITER, mindest = VORLAUF_MINDEST) {
    if (gewartetMs <= NACHLASS_AB)
        return voll;
    if (gewartetMs >= NACHLASS_BIS)
        return mindest;
    const anteil = (gewartetMs - NACHLASS_AB) / (NACHLASS_BIS - NACHLASS_AB);
    return voll - (voll - mindest) * anteil;
}
/**
 * Wie lange gewartet werden darf, bevor die Wiedergabe trotzdem weiterläuft.
 *
 * Eine Garantie, die ewig wartet, ist keine: ein Video, das nie fertig lädt,
 * würde den Schnitt für immer anhalten. Nach `grenze` läuft es weiter, und
 * der Befund sagt, dass es passiert ist.
 */
export function pufferAbgelaufen(seitMs, grenze = 8000) {
    return seitMs >= grenze;
}
//# sourceMappingURL=puffer.js.map